import React from 'react';
import Button from '@mui/material/Button';
import styled from 'styled-components';
import NumericalCircle, { INumericalCircleProps } from './NumericalCircle';

interface IncrementTextButtonProps {
  buttonBackgroundColor: string;
  buttonTextColor: string;
  buttonText: string;
  circleProps: INumericalCircleProps;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const StyledButton = styled(Button)`
  font-weight: inherit;
  font-size: inherit;
  line-height: inherit;
  text-transform: inherit;
  padding: 6px;
  margin-left: 12px;
  height: 32px;
`;

const CircleWrapper = styled.div`
  margin-left: 7px;
`;

const IncrementTextButton: React.FC<IncrementTextButtonProps> = ({
  buttonBackgroundColor,
  buttonTextColor,
  buttonText,
  circleProps,
  onClick,
}) => (
  <StyledButton
    aria-label="info"
    aria-describedby="info-button"
    onClick={onClick}
    style={{ backgroundColor: buttonBackgroundColor, color: buttonTextColor, position: 'relative' }}
  >
    {buttonText}
    <CircleWrapper><NumericalCircle {...circleProps} /></CircleWrapper>
  </StyledButton>
);

export default IncrementTextButton;
